<div class="summary-box__list-wrapper">
  <ul class="summary-box__list">
    <li *ngFor="let summary of items">
      <summary-item [summary]="summary" />
    </li>
  </ul>
</div>
